import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

import { useStyles } from "./Styles";

const propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.string.isRequired,
};

export const LabeledDataItem = (props) => {
  const styles = useStyles();
  return (
    <>
      <small className={styles.label}>
        <Box sx={{ display: { sm: 'block', xs: 'block' } }}>{props.label}</Box>
        <Box sx={{ display: { sm: 'block', xs: 'none' } }}/>
        {props.data}
      </small>
    </>
  );
};

LabeledDataItem.prototype = propTypes;

export default LabeledDataItem;
